<template>
	<dialog-slot
			title="Information"
			@updateClose="closeDialog"
			@updateSave="closeDialog"
			width="600px"
			is-cancel-hide
			apply-text="Close"
	>
		<div class="comments">
			<div  v-if="!isInformation" class="comments_header">
				<div class="comments_header-title">
					<span><span class="italic">Unit#:</span> {{ getUnit }}</span>
					<span><span class="italic">Unit type:</span> {{ getUnitType }}</span>
				</div>
			</div>

			<div class="comments_body">
				<ol v-if="Array.isArray(commentsList) && commentsList.length">
					<li v-for="(item, idx) in commentsList" :key="item.msg + idx">{{ item.msg }}</li>
				</ol>

				<span class="information" v-else-if="isInformation">{{ commentsList }}</span>

				<div v-else>no comments yet</div>
			</div>
		</div>
	</dialog-slot>
</template>

<script>
import DialogSlot from "@/shared/DialogSlot/DialogSlot.vue";

export default {
	name: "CommentsPopup",
	components: { DialogSlot },
	props: {
		commentsList: [ Array, String ],
		commentsData: Object,
		isInformation: Boolean
	},
	computed: {
		getUnit() {
			return this.commentsData?.unit ?? "-";
		},
		getUnitType() {
			return this.commentsData?.unit_type ?? "-";
		}
	},
	methods: {
		closeDialog() {
			this.$emit('updateCloseComments');
		}
	}
};
</script>

<style scoped lang="scss">
.comments {

	.information {
		font-size: 14px;
		color: var(--card-color);
	}

	&_body {

	}

	.groupField_wrap {
		display: flex;
	}

	[type="button"] {
		line-height: 1;
	}

	.flexBlock {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	&_header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px;

		&-title {
			span {
				display: inline-block;
				margin-right: 10px;
			}

			.italic {
				margin-right: 0;
				color: var(--base-orange);
			}
		}
	}

}
</style>
